var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotesMedical = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "notes-medical",
    d: "M5.333,34.667a1.332,1.332,0,0,1,1.333-1.333H17.333a1.332,1.332,0,0,1,1.333,1.333V42.9a1.331,1.331,0,0,1-.392.942l-2.438,2.438a1.331,1.331,0,0,1-.942.392H6.667a1.332,1.332,0,0,1-1.333-1.333ZM4,34.667V45.333A2.669,2.669,0,0,0,6.667,48H14.9a2.668,2.668,0,0,0,1.887-.779l2.438-2.437A2.668,2.668,0,0,0,20,42.9V34.667A2.669,2.669,0,0,0,17.333,32H6.667A2.669,2.669,0,0,0,4,34.667Zm9.333,16.667a.669.669,0,0,0-.667-.667H5.333a4,4,0,0,1-4-4v-10a.667.667,0,0,0-1.333,0v10A5.333,5.333,0,0,0,5.333,52h7.333A.669.669,0,0,0,13.333,51.333Zm-2-16A1.332,1.332,0,0,0,10,36.667V38H8.667a1.332,1.332,0,0,0-1.333,1.333v1.333A1.332,1.332,0,0,0,8.667,42H10v1.333a1.332,1.332,0,0,0,1.333,1.333h1.333A1.332,1.332,0,0,0,14,43.333V42h1.333a1.332,1.332,0,0,0,1.333-1.333V39.333A1.332,1.332,0,0,0,15.333,38H14V36.667a1.332,1.332,0,0,0-1.333-1.333Zm0,1.333h1.333v2a.669.669,0,0,0,.667.667h2v1.333h-2a.669.669,0,0,0-.667.667v2H11.333v-2a.669.669,0,0,0-.667-.667h-2V39.333h2a.669.669,0,0,0,.667-.667Z",
    transform: "translate(0 -32)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotesMedical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notes-medical.ae4a830d4c883c381f37bb30eb8e8569.svg";